fragment ProductAttributeOptionFragment on ProductAttributeOption {
    id

    attribute {
        ...ProductAttributeFragment
    }

    media {
        ...MediaFragment
    }

    attribute_id
    media_id

    value
    translations

    payload
}